import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  RESET_CATEGORY_STATE,
} from '../../../types/category';

const initialState = {
  loading: false,
  categories: [],
  error: null,
  success: false,
};

const fetchCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.data,
        success: true,
      };

    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case RESET_CATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchCategoriesReducer;
